import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

import { REQUEST_LIST_CANNED_PROMPTS } from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/eisenhower/eisenhowerMsgs";
import "./cannedMsgReciever";

export const requestCannedPrompts = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_CANNED_PROMPTS);
};
